import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { useAppMutation } from 'services/reactQuery/useAppMutation';
import { commonTexts, groupsTexts } from 'consts/text';
import { queryClient } from 'services/reactQuery/queryClient';
import { useCurrentInstitution } from 'jotaiAtoms/currentInstitution';
import { GetGroupsFilters } from 'types';

type GroupsPageNetworkManageParams = {
    filtersValues: GetGroupsFilters;
    onGroupArchiveRequestFinish: () => void;
};

export const useGroupsPageNetworkManage = ({
    filtersValues,
    onGroupArchiveRequestFinish,
}: GroupsPageNetworkManageParams) => {
    const { id: institutionId } = useCurrentInstitution();
    const { displaySuccess, displayError } = useSimpleNotification();

    const {
        data: groupsData,
        isInitialLoading: isGroupsDataInitialLoading,
        isRefetching: isGroupsDataRefetching,
        isError: isGroupsDataError,
    } = useAppQuery('GROUPS', [filtersValues], () =>
        StaffHTTPService.groups.getGroups(filtersValues),
    );

    const { mutate: archiveGroup, isLoading: isArchiveGroupLoading } = useAppMutation(
        StaffHTTPService.groups.archiveGroup,
        {
            key: ['GROUPS'],
            onSuccess: async (_, variables) => {
                onGroupArchiveRequestFinish();
                // variables is GroupId
                await queryClient.invalidateQueries([institutionId, 'GROUP', variables]);
                displaySuccess(groupsTexts.successfullyArchiveGroupMessage);
            },
            onError: () => {
                onGroupArchiveRequestFinish();
                displayError(commonTexts.errorMessages.actionExecution);
            },
            invalidateQueryKeys: [
                ['GROUPS'],
                ['MENUS_GROUPS'],
                ['JOURNALS_GROUPS'],
                ['MAIL_THREAD_RECEIVERS'],
                ['EMPLOYEES'],
                ['GROUPS_EMPLOYEES'],
                ['CHILDREN'],
            ],
        },
    );

    return {
        groupsData,
        isGroupsDataInitialLoading,
        isGroupsDataRefetching,
        isGroupsDataError,
        isOptionsLoading: isArchiveGroupLoading,
        isArchiveGroupLoading,
        archiveGroup,
    };
};
